<template>
    <v-container fluid>
        <v-card >
            <v-toolbar>
                <v-icon>attach_money</v-icon>
                <v-toolbar-title class="font-weight-light">Modificación de Canal de Venta</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
        
            <v-card-text>
                <v-container fluid>
                    <v-layout column>
                        <v-flex xs12 >
                            <v-card dark color="blue ligthten-3">
                                <v-card-text>
                                <div >{{Solicitud.infoCanalVenta}} </div>
                                </v-card-text>
                            </v-card>
                        </v-flex>

                        <v-flex xs12 >
                            <v-checkbox label="Modificar Canal de Venta" v-model="modificaCanalVenta"></v-checkbox>
                            <v-autocomplete v-model="nuevoCanalVentaId" :items="listCanalesVenta" autocomplete="disabled" v-if="modificaCanalVenta"
                                    item-text="nombre" item-value="id" label="a través del Canal de Venta" :menu-props="{minWidth:'200'}"></v-autocomplete>
                        </v-flex>

                        <v-flex xs12 >
                            <v-text-field label="Ingrese el Motivo del Cambio" v-model="motivoCambio"></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-container>

            </v-card-text>
            <v-card-actions>
                <v-btn color="cancel" @click="cancelar">Cancelar</v-btn>
                <v-spacer></v-spacer>
                <v-btn  color="success" @click="confirmar" :disabled="!modificaCanalVenta">Confirmar</v-btn>
            </v-card-actions>
        </v-card>

    </v-container>
    
</template>

<script>

import Vue from 'vue'
import { http } from '@/axios'

import {
  mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export default {
    data () {
        return {
            loading: false,
            modificaCanalVenta: false,
            empresaId: 0,
            nuevoCanalVentaId: 0,
            motivoCambio: '',
            listCanalesVentaHabilitados:[],
            listEmpresas:[]
        }
    },
    async created() {
        //this.loadCanalesVentaHabilitados();
    },
    props:{
        Solicitud: {
            type: Object,
        },
        Ok: Function,
        Cancel: Function,
    }, 
    watch:{ 
        'Solicitud': function(){
            if(this.Solicitud){
               this.loadData();
            }
        },
        'modificaCanalVenta': function(){
            if(this.modificaCanalVenta){
                this.loadCanalesVentaHabilitados();
            }
        },
    }, 
    computed:{
        ...mapGetters(['user', 'DebugModeOn', 'UiCustomUserSettings']),
        listCanalesVenta: function (){
        // devuelvo los canales de venta de la empresa seleccionada
        let canalesDisponibles =this.listCanalesVentaHabilitados.filter(i=>i.empresaId == this.Solicitud.empresaId)
        
        return canalesDisponibles
        },
    },
    methods:{
        ...mapMutations(["alertClear", "alertSuccess", "alertWarning", "alertError"]),
        loadData(){
            this.nuevoCanalVentaId = this.Solicitud.canalVentaId;
        },
        async confirmar(){

            if(this.modificaCanalVenta && (this.nuevoCanalVentaId == this.Solicitud.canalVentaId)){
                this.alertWarning('Se marcó Modificar el Canal de Venta, pero es igual al cargado para la solicitud. Por favor, verifique, o destilde la opción.');
                return;
            }
            
            if(this.motivoCambio == ''){
                this.alertWarning('Ingrese el motivo del cambio.');
                return;
            }
            
            var params = {};
            params.creditoId = this.Solicitud.id;
            params.canalVentaId = this.nuevoCanalVentaId;

            params.motivo = this.motivoCambio;

            this.loading = true

            try {
                var res = await http.post('creditos/actualizarcanalventadesolicitud', JSON.stringify( {parametros:  params} ) );

                Vue.$log.debug(res);
                this.alertSuccess('Se han modificado los datos del crédito.')

                this.cleanUp();
                this.Ok();
            } catch (error) {
                // Error
                this.alertError(error)
            }
            this.loading = false            
        },
        async cancelar(){
            this.modificaCanalVenta = false;

            this.loadData();
            this.Cancel();
        },
        async cleanUp(){
            this.modificaCanalVenta = false;
            this.nuevoCanalVentaId = 0;
            this.listCanalesVentaHabilitados = [];
        },
        
        async loadCanalesVentaHabilitados() {
            this.loading = true
            try {
                var result = await http.get('canalesventa/habilitadosparausuario?soloActivos=true&usuarioId='+ this.user.id ); // traigo todas
                this.listCanalesVentaHabilitados = result.list;

                // extraigo las empresas de los canales habilitados
                this.listEmpresas = Array.from(new Set(this.listCanalesVentaHabilitados.map(i=>i.empresaId)))
                .map(id => {
                return {
                    id: id,
                    nombre: this.listCanalesVentaHabilitados.find(s=>s.empresaId === id).empresaDescripcion,
                    color: this.listCanalesVentaHabilitados.find(s=>s.empresaId === id).empresaColor
                }
                })
            
            // selecciono la empresa predefinida del usuario
            if(this.UiCustomUserSettings.empresaPredeterminadaId > 0){
                if(this.listEmpresas.find(i=> i.id === this.UiCustomUserSettings.empresaPredeterminadaId)){
                this.empresaId = this.UiCustomUserSettings.empresaPredeterminadaId
                }
            }

            // selecciono el canal de venta predefinido del usuario
            if(this.UiCustomUserSettings.canalVentaPredeterminadoId > 0){
                if(this.listCanalesVentaHabilitados.find(i=> i.id === this.UiCustomUserSettings.canalVentaPredeterminadoId)){
                this.nuevoCanalVentaId = this.UiCustomUserSettings.canalVentaPredeterminadoId
                }
            }

            } catch (error) {
                // Error
                this.alertError(error)
            }
            this.loading = false
        },
    
  }
}
</script>
